import { ITemplateFormData, TEMPLATES } from "@home-health-notify/domain";
import { JsonForms } from "@jsonforms/react";
import { reorderUiSchema, templatesInfoMap } from "hhn-commons";
import { useEffect, useMemo, useState } from "react";
import { IMessageContentTypeBubble } from "../../MessagePanel";
import viewRenderers from "../../templates/viewRenderers";
import { FormContentWrapper, FormDetailTitle } from "./FormContent.style";
import { Loader } from "../../messagePanelMenu/MessagePanel.style";
import ExpandableText from "../../../common/ExpandableText";

export const FormContent = ({
  message,
  chatInfoAccess,
}: IMessageContentTypeBubble) => {
  const messageData = message.getMessage();
  const [formData, setFormData] = useState<ITemplateFormData>();
  const templateKey = messageData.form?.templateType as keyof typeof TEMPLATES;
  const template = chatInfoAccess?.getTemplateByKey?.(templateKey);
  const [isLoading, setIsLoading] = useState<boolean>(!!template);

  const selectedTemplateInfo = useMemo(() => {
    return {
      ...templatesInfoMap[templateKey],
      form: template,
    };
  }, [template, templateKey]);

  useEffect(() => {
    if (selectedTemplateInfo?.form && messageData.form) {
      if (selectedTemplateInfo?.form?.payloadToFormDataHandler) {
        const payloadToFormData =
          selectedTemplateInfo?.form?.payloadToFormDataHandler(
            messageData,
            selectedTemplateInfo?.form,
          );
        setFormData(payloadToFormData);
        setIsLoading(false);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [messageData?.form, chatInfoAccess]);

  const reorderedUiSchema = useMemo(() => {
    return reorderUiSchema(selectedTemplateInfo);
  }, [selectedTemplateInfo]);

  return (
    <FormContentWrapper>
      <FormDetailTitle data-testid="form-title">
        <ExpandableText>{messageData.body}:</ExpandableText>
      </FormDetailTitle>
      {selectedTemplateInfo?.form && formData && reorderedUiSchema ? (
        <JsonForms
          schema={selectedTemplateInfo?.form.schema}
          uischema={reorderedUiSchema}
          data={formData}
          renderers={viewRenderers}
        />
      ) : isLoading ? (
        <Loader />
      ) : (
        <pre>
          <ExpandableText>{messageData.fallbackMessage}</ExpandableText>
        </pre>
      )}
    </FormContentWrapper>
  );
};
